export const strictEq = a => b => a === b;

export const anyEq = (...toMatch) => value => toMatch.filter(strictEq(value)).length > 0;

export const assign = key => value => (obj = {}) => ({ ...obj, [key]: value });

export const compose = (...fns) => fns.reduce((f, g) => (...args) => f(g(...args)));

export const transform = transformations => (object = {}) => {
    if (!object) {
        return undefined;
    }

    return Object.entries(transformations).reduce(
        (acc, [key, t]) => {
            if (acc[key]) {
                acc[key] = t(acc[key]);
            }
            return acc;
        },
        { ...object }
    );
};

const matched = x => ({
    on: () => matched(x),
    otherwise: () => x
});

/**
 * Simple implementation of pattern matching
 *
 * match accepts a single value to match on,
 * and returns an object with on and otherwise options
 *
 * on accepts two functions:
 * First parameter is the test
 * Second parameter is what to do if it passes
 *
 * Otherwise accepts one function, which is what to do if all else fails
 *
 * No values will be returned until an 'otherwise' is executed.
 *
 * Example usage:
 * match(50)
 *   .on(x => x =< 0, () => 0)
 *   .on(x => x === 1, x => x)
 *   .otherwise(x => x % 2) // returns 50 % 2
 */
export const match = x => ({
    on: (predicate, fn) => (predicate(x) ? matched(fn(x)) : match(x)),
    otherwise: fn => fn(x)
});
